/*
======================================================
BYMOQA Material Engine
Version 1
======================================================
*/

window.initBymoqaMaterial = function(app){

    const header =
        app.header;

    const material =
        header.querySelector(".bymoqa-material");

    const light =
        header.querySelector(".bymoqa-highlight");

    const rim =
        header.querySelector(".bymoqa-rim");

    if(!material) return;

    let mouseX=0;
    let mouseY=0;

    let currentX=0;
    let currentY=0;

    let inside=false;

    function animate(){
        // mouseX = app.pointer.x;
        // mouseY = app.pointer.y;

        // inside = app.pointer.inside;

        mouseX = Number.isFinite(app.pointer?.x)
    ? app.pointer.x
    : currentX;

mouseY = Number.isFinite(app.pointer?.y)
    ? app.pointer.y
    : currentY;

inside = !!app.pointer?.inside;

        const smooth =
    ('ontouchstart' in window)
        ? 0.18
        : 0.08;

currentX += (mouseX-currentX) * smooth;
currentY += (mouseY-currentY) * smooth;

        // console.log(currentX, currentY);

        light.style.transform =
`translate(${currentX - 350}px,${currentY - 350}px)`;

        const rotateY =
            ((currentX/header.offsetWidth)-0.5)*5;

        const rotateX =
            ((currentY/header.offsetHeight)-0.5)*-5;


        material.style.transform =
        `
        perspective(1200px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
        `;

        // ].log(rotateX, rotateY);

        rim.style.opacity =
            inside
            ? .95
            : .65;

        requestAnimationFrame(animate);

    }

    animate();
}